export interface SpanEntry {
  id: string
  day_of_week?: number | null
  lesson_number?: number | null
  time_slot_name?: string | null
  ampel_reasons?: string[]
  pdf_raw_text?: string | null
}

export function spanActionLabel(
  direction: 'up' | 'down',
  entry: SpanEntry,
  neighbor: SpanEntry | null,
): string {
  const arrow = direction === 'up' ? '↑' : '↓'
  const fallback = entry.lesson_number != null
    ? entry.lesson_number + (direction === 'up' ? -1 : 1)
    : null
  const slot = neighbor?.lesson_number ?? fallback
  if (neighbor) return `${arrow} Mit L${slot ?? '?'} fusionieren`
  return direction === 'up' ? `${arrow} Nach oben erweitern` : `${arrow} Nach unten erweitern`
}
